import {useEffect, useRef} from 'react';
import MetisMenu from 'metismenujs';

const useMetisMenu = () => {
    const menuRef = useRef(null);
    const menuInstance = useRef(null);

    useEffect(() => {
        if (menuRef.current) {
            if (menuInstance.current) {
                menuInstance.current.dispose();
            }
            menuInstance.current = new MetisMenu(menuRef.current);
        }

        return () => {
            if (menuInstance.current) {
                menuInstance.current.dispose();
            }
        };
    }, []);

    return menuRef;
};

export default useMetisMenu;
